// represents the amount of space between comments with 'spread' being slightly
// greater spacing than 'default'
export type CommentSpacing = 'spread' | 'default';

export enum CommentContentType {
  WHITEBOARD = 'WHITEBOARD',
  DATABASE = 'DATABASE',
}

export enum ReactionsResourceType {
  whiteboard = 'whiteboard',
  database = 'database',
}

export const mapCommentContentTypeToResourceType = (
  contentType: CommentContentType
): ReactionsResourceType | undefined => {
  switch (contentType) {
    case CommentContentType.WHITEBOARD:
      return ReactionsResourceType.whiteboard;
    case CommentContentType.DATABASE:
      return ReactionsResourceType.database;
    default:
      return undefined;
  }
};
